<script setup lang="ts">
import { computed } from 'vue';
import Checkbox from 'primevue/checkbox';
import Fluid from 'primevue/fluid';
import InputNumber from 'primevue/inputnumber';

interface Props {
  optionAir: any;
  optionAdults: any;
  optionChild: any;
  optionIndex: number;
  isShowError: boolean;
  classType: boolean;
  errorMessage?: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:optionAir': [value: any];
  'update:optionAdults': [value: any];
  'update:optionChild': [value: any];
  'update:optionIndex': [value: number];
  'update:isShowError': [value: boolean];
  'update:classType': [value: boolean];
  'update:errorMessage': [value: string];
  updateClass: [event: any, optionIndex: number];
}>();

const option = computed({
  get() {
    return props.optionAir;
  },
  set(value) {
    emits('update:optionAir', value);
  }
});

const optionAdults = computed({
  get() {
    return props.optionAdults;
  },
  set(value) {
    emits('update:optionAdults', value);
  }
});

const optionChild = computed({
  get() {
    return props.optionChild;
  },
  set(value) {
    emits('update:optionChild', value);
  }
});

const onUpdateCheckBox = (event: any) => {
  emits('updateClass', event, props.optionIndex);
};
</script>
<template>
  <div class="air-class-number">
    <div class="grid">
      <div class="col-12 md:col-6 checkbox-form">
        <Fluid>
          <div class="field">
            <div>
              <Checkbox class="class-checkbox" :inputId="classType ? 'economy' + optionIndex : 'business' + optionIndex" v-model="option" :binary="true" @update:modelValue="onUpdateCheckBox($event)" />
              <label class="ml-1" :for="classType ? 'economy' + optionIndex : 'business' + optionIndex">{{ classType ? $t('worksheet.economy_class_checkbox') : $t('worksheet.business_checkbox') }}</label>
            </div>
          </div>
        </Fluid>
      </div>
    </div>
    <div class="grid input-age" v-if="option">
      <div class="col-12 md:col-6">
        <Fluid>
          <div class="field">
            <div>{{ $t('advance_quote.form.adult') }}</div>
            <InputNumber class="input-adult" :min="0" v-model="optionAdults" :class="isShowError && errorMessage ? 'p-invalid' : ''" />
            <span class="text-red-500" v-if="isShowError">
              {{ errorMessage }}
            </span>
          </div>
        </Fluid>
      </div>
      <div class="col-12 md:col-6">
        <Fluid>
          <div class="field">
            <div>{{ $t('advance_quote.form.children') }}</div>
            <InputNumber class="input-child" :min="0" v-model="optionChild" />
          </div>
        </Fluid>
      </div>
    </div>
  </div>
</template>
